import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { GroupClass } from '../models/groupClass';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class GroupClassService {

  private groupClassApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.groupClassApiUrl = this.appSettings.DB_API_ENDPOINT + 'group_classes/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllGroupClass(): Promise<Array<GroupClass>> {
    return  this.http.get(this.groupClassApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addGroupClass(gymId: string, editGroupClass: any): Observable<any> {
    return this.http.post(
      this.appSettings.DB_API_ENDPOINT + 'gyms/' + gymId + '/group_classes', editGroupClass, this.appSettings.apiOptions)
     .map(this.getDataInJson);
  }

  public delGroupClass(id): Observable<any> {
    return this.http.delete(this.groupClassApiUrl + id, this.appSettings.apiOptions);
  }

  public editGroupClass(editGroupClass): Observable<any> {
    return this.http.put(this.groupClassApiUrl + editGroupClass._id, editGroupClass, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/group-class.service.ts